import { styled } from "@jog/theming"
import classNames from "classnames"
import { PropsWithChildren } from "react"

const REM_BASE = 10
const parseRemSize = (size?: string) => {
    if (!size) return ""
    if (!/rem$/.test(size)) return ""
    const rem = +size.replace(/rem$/, "")
    if (isNaN(rem)) return ""
    return `${rem * REM_BASE}px`
}

export const CTABase = ({
    children,
    fontSizeMobile,
    borderWidth,
    borderColor,
    color,
    bgColor,
    bgColorHover,
    colorHover,
    className,
}: PropsWithChildren<{
    fontSizeMobile: string
    borderWidth: number
    color: string
    bgColor: string
    borderColor: string
    bgColorHover: string
    colorHover: string
    className?: string
}>) => (
    <CTAStyle
        bgColorHover={bgColorHover}
        colorHover={colorHover}
        fontSize={parseRemSize(fontSizeMobile)}
        className={classNames(
            "font-primary inline-block whitespace-nowrap border-solid bg-transparent font-normal",
            className
        )}
        css={{
            background: bgColor,
            borderColor,
            borderWidth,
            color,
        }}>
        {children}
    </CTAStyle>
)

const CTAStyle = styled.span<{
    bgColorHover?: string
    colorHover?: string
    fontSize: string
}>`
    @media screen and (max-width: 1199px) {
        ${({ fontSize }) => fontSize && `font-size: ${fontSize};`}
    }
    &:hover {
        ${({ bgColorHover }) => bgColorHover && `border-color: ${bgColorHover}`};
        ${({ bgColorHover }) => bgColorHover && `background: ${bgColorHover}`};
        ${({ colorHover }) => colorHover && `color: ${colorHover}`};
    }
`
